var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.VueperSlides,
    {
      staticClass: "no-shadow MySlider",
      attrs: {
        "slide-ratio": _setup.props.slideRatio,
        lazy: "",
        "lazy-load-on-drag": "",
      },
    },
    _vm._l(_setup.slides, function (slide) {
      return _c(_setup.VueperSlide, {
        key: _setup.slide_id(slide),
        attrs: {
          image: _setup.slide_src(slide),
          title: _setup.slide_title(slide),
        },
        scopedSlots: _vm._u(
          [
            {
              key: "loader",
              fn: function () {
                return [_c(_setup.Loader, { staticClass: "loader" })]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }